var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('procedure-forms-editor',{attrs:{"site-id":_vm.siteId,"forms-settings":_vm.formsSettings,"initial-tab":_vm.initialTab},on:{"close":function($event){return _vm.$emit('close')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }